import PageNotFoundController from './page-not-found-controller'

export default PageNotFoundController
